<script setup lang="ts">
import ImageEventDefault from '@/assets/svgs/imageEventDefault.svg'
import { Swiper } from 'swiper'
import 'swiper/css/bundle'

const { $get, $post } = useApi()
const { formatDate } = useDate()

const route = useRoute()
const { getTime } = useDate()
const now = new Date()

const deviceId = useCookie(COOKIE_KEYS.deviceId)
const authToken = useCookie(COOKIE_KEYS.authToken)

const {
  public: { widgetUrl }
} = useRuntimeConfig()

const { data: state, error } = await useAsyncData(
  `activity page data by - ${route.params.id}`,
  async () => {
    const [activity, events] = await Promise.all([
      $get(`/api/v1/activity/${route.params.id}`),
      $get(
        `/api/v1/event?scheduleInfo.saleEnding_gte=${new Date(
          new Date(now)
        ).toISOString()}&scheduleInfo.saleOpening_lte=${new Date(
          new Date(now)
        ).toISOString()}&activityId=${route.params.id}&_sort=scheduleInfo.sessionDate:asc`
      )
    ])

    return { activity, events }
  },
  {
    default: () => ({ activity: null, events: [] })
  }
)

if (error.value) {
  console.error('Error in async data:', error.value)
  // Handle the error appropriately, e.g., show a message to the user
}

const selectedEvent = computed({
  get: () => {
    console.log(route.query?.eventId)
    return route.query?.eventId
      ? route.query?.eventId
      : state.value?.events.filter((el) => el.scheduleInfo.saleStatus === 'opened')[0]?.id || ''
  },
  set: async (value: string) => {
    await navigateTo(`/activities/${route.params.id}?eventId=${value}`)
  }
})

const currentEvent = computed(() => {
  if (!state.value?.events?.length) return undefined;
  return state.value.events.find((el) => el.id === selectedEvent.value) || undefined
})

const colors = [
  { label: 'Blue 300', code: '165db7' },
  { label: 'Blue 200', code: '2070bf' },
  { label: 'Blue 100', code: '2983c7' },
  { label: 'Green 300', code: '288f6f' },
  { label: 'Green 200', code: '279b17' },
  { label: 'Green 100', code: '89a81d' },
  { label: 'Yellow 200', code: 'f09a1a' },
  { label: 'Yellow 100', code: 'EAB522' },
  { label: 'Orange', code: 'f57e11' },
  { label: 'Red 200', code: 'd82422' },
  { label: 'Red 100', code: 'e7511a' },
  { label: 'Violet 300', code: '77185e' },
  { label: 'Violet 200', code: '7915ad' },
  { label: 'Violet 100', code: 'a91d68' },
  { label: 'Brown', code: '741a0e' }
]

const getRandomColor = () => colors[Math.floor(Math.random() * (colors.length - 1))].code

onMounted(() => {
  if (import.meta.client) {
    new Swiper('.datesSwiper', {
      freeMode: true,
      spaceBetween: 28,
      // loop: true,
      slidesPerView: 'auto',
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    })

    if (deviceId.value && state.value?.events.length) {
      const eventId = route.query?.eventId ?? state.value?.events[0]?.id
      $post('/api/v1/viewed-events', {
        deviceId: deviceId.value,
        eventId,
        activityId: route.params.id
      }).catch(console.error)
    }
  }
})

const hrefDesktop = computed(
  () => state.value?.activity ?
    `${widgetUrl}/${selectedEvent.value}/fullscreen?${authToken.value ? `authToken=${authToken.value}` : ''
    }` : ''
)
const hrefMobile = computed(
  () => state.value?.activity ?
    `${widgetUrl}/${state.value?.activity.id}?${authToken.value ? `authToken=${authToken.value}` : ''
    }` : ''
)

const head = computed(() => {
  if (state.value?.activity)
    return {
      title: `${state.value?.activity.title}`,
      meta: [
        {
          hid: 'title',
          property: 'title',
          content: `${state.value?.activity.title}`
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${state.value?.activity.title}`
        },
        {
          hid: 'description',
          property: 'description',
          content: `${state.value?.activity.description}`
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: `${state.value?.activity.description}`
        },
        {
          hid: 'keywords',
          property: 'keywords',
          content: `${state.value?.activity.title}, ${state.value?.activity.organization.name}, ${state.value?.activity.category.title
            }, ${replaceCategory(
              state.value?.activity.snippet
            )}, Абхазия, Сухум, Гагра, Гудаута, Ткуарчал, Гал, Очамчыра, Гулрыпш, купить билеты, тикет ми, тикетми, тикетмибиз, расписание, афиша, билет`
        },
        {
          hid: 'url',
          name: 'url',
          content: `https://ticketme.biz/activities/${state.value?.activity.id}`
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://ticketme.biz/activities/${state.value?.activity.id}`
        },
        {
          hid: 'image',
          name: 'image',
          content: `${state.value?.activity.image?.uploadURL ?? ImageEventDefault}`
        },
        {
          name: 'og:image',
          property: 'og:image',
          content: `${state.value?.activity.image?.uploadURL ?? ImageEventDefault}`
        }
      ]
    }
  else {
    return {}
  }
})

function replaceCategory(category: string) {
  const prepositions = [
    'в',
    'на',
    'с',
    'по',
    'за',
    'под',
    'над',
    'из',
    'к',
    'от',
    'из-за',
    'из-под',
    'и',
    'а',
    'но',
    'для',
    'у',
    'о',
    'об'
  ]
  const words = category.split(' ')
  const result = words
    .map((word) => {
      const item = word.replace(/[.,!?;'"-]/g, '')
      if (prepositions.includes(item)) {
        return ''
      } else {
        return item
      }
    })
    .filter((word: string) => word !== '')
    .join(',')
  console.log(result)
  return result
}

useHead(head)

const errorMessage = computed(() => {
  if (!error.value) return null;

  // You can customize these messages based on specific error types if needed
  return "Упс! У нас возникли проблемы с загрузкой этой страницы. Пожалуйста, попробуйте позже.";
});
</script>

<template>
  <NuxtLayout name="shop-layout">
    <section v-if="state.activity && state.events">
      <t-activities-preview :activity="state.activity" :has-event="state.events.length > 0" :event="currentEvent"
        class="mb-8 lg:mb-10" />
      <div v-if="state.events.length > 0" id="buy" class="container flex-col gap-3 xl:gap-4"
        :class="currentEvent?.tariff?.type === 'free' ? 'flex pb-8' : 'hidden lg:flex pb-20'">
        <h4 class="px-4 xl:px-0 text-xl lg:text-4xl font-bold font-sf-pro text-gray-900">
          Расписание события
        </h4>
        <div class="datesSwiper px-4 xl:px-0 overflow-hidden">
          <div class="swiper-wrapper xl:pl-1 py-3">
            <button v-for="event in state.events" :key="event.id" class="swiper-slide" :class="`bg-white px-6 !w-fit py-5 min-h-24 min-w-54 text-xl flex flex-row gap-5 border-2 ${event.id === selectedEvent ? `border-decorative-yellow` : `border-white`
              } ${event.scheduleInfo.saleStatus === 'closed' ? 'opacity-60 cursor-not-allowed' : ''
              }`" style="box-shadow: 0px 0px 12px #0000001f; border-radius: 14px"
              @click="event.scheduleInfo.saleStatus === 'opened' ? (selectedEvent = event.id) : ''">
              <div class="max-w-1 w-1 rounded h-full min-h-14 text-left"
                :style="{ backgroundColor: `#${getRandomColor()}` }" />
              <div class="min-h-14 flex flex-col font-sf-pro text-xl justify-between text-left">
                <p class="text-left font-medium">
                  {{ formatDate(event.scheduleInfo.sessionDate, 'D MMMM') }}
                </p>
                <p class="text-left">
                  {{ `${getTime(event.scheduleInfo.sessionDate)}` }}
                </p>
              </div>
            </button>
          </div>
        </div>
        <iframe class="w-full h-200 px-4 xl:px-0" :src="hrefDesktop" v-if="(currentEvent?.tariff?.type == 'canvas' || currentEvent?.tariff?.type === 'entrance') &&
          currentEvent.scheduleInfo.saleStatus === 'opened'
        " frameborder="0" />
        <div v-else-if="currentEvent.scheduleInfo.saleStatus === 'closed'" class="px-4 xl:px-0 font-sf-pro text-base">
          <h3 class="text-2xl">Продажи на данную дату временно приостановлены</h3>
        </div>
        <div v-else-if="currentEvent?.tariff?.type === 'free'" class="px-4 xl:px-0 font-sf-pro text-base">
          <h3 class="text-2xl">Вход на данное событие свободный</h3>
        </div>
        <div v-else-if="currentEvent?.tariff?.type === 'offline'" class="px-4 xl:px-0 font-sf-pro text-base">
          <h3 class="text-2xl">Билеты можно приобрести только в кассе</h3>
        </div>
      </div>
      <t-activities-description :activity="state.activity" class="pb-8 lg:pb-14" />
      <t-activities-media :media="state.activity.mediateca" :video="state.activity.video"
        :video-stub="state.activity.image" class="pb-8 lg:pb-14" />
      <t-activities-staff :participants="state.activity.staff" class="pb-8 lg:pb-17" />

      <t-activities-map v-if="state.events.length > 0" :data="currentEvent" class="pb-10 md:pb-17" />
      <client-only>
        <t-main-watched class="pb-5 md:pt-0 md:pb-0" />
      </client-only>
      <div v-if="state.events.length > 0" class="block lg:hidden z-100 fixed bottom-20 right-4"
        :class="currentEvent?.tariff?.type === 'free' ? 'w-35' : 'w-46'">
        <t-button v-if="currentEvent?.tariff?.type === 'free'" rounded="large"
          class="font-normal w-full text-lg !font-normal font-sf-pro h-11">
          <span>Бесплатно</span>
        </t-button>
        <t-button v-else-if="currentEvent?.tariff?.type === 'offline'" rounded="large"
          class="font-normal w-full text-lg !font-normal font-sf-pro h-11">
          <span>Билеты в кассе</span>
        </t-button>
        <t-button v-else rounded="large" class="font-normal w-full text-lg !font-normal font-sf-pro h-11"
          :to="hrefMobile">
          <div class="flex justify-center flex-row items-center space-x-2">
            <a-icon-ticket class="w-4 h-3" color="#FFFFFF" />
            <span>Купить билет</span>
          </div>
        </t-button>
      </div>
    </section>
    <section v-else-if="errorMessage" class="container mx-auto px-4 py-12 text-center h-full">
      <h2 class="text-2xl font-bold text-black mb-4">{{ errorMessage }}</h2>
      <p class="text-black mb-8">Приносим извинения за неудобства.</p>
      <t-button @click="$router.go(0)" rounded="large" class="font-normal text-lg mx-auto">
        Попробовать снова
      </t-button>
    </section>
    <section v-else class="container mx-auto px-4 py-12 text-center">
      <p class="text-xl text-gray-600">Загрузка...</p>
    </section>
  </NuxtLayout>
</template>
